import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { SUPERSET_CONFIG } from '@core/config/superset.config';

/**
 * Scope (país/partner) que viaja al backend para que este pueda aplicar
 * Row Level Security al emitir el guest token de Superset.
 */
export interface SupersetGuestTokenScope {
  countryId?: string | null;
  partnerId?: string | null;
}

interface SupersetGuestTokenResponse {
  token: string;
}

/**
 * Cliente del endpoint propio (backend JRS) que emite el guest token de Superset.
 * El guest token en sí NUNCA se genera en el frontend: requiere credenciales de
 * administrador de Superset que solo puede manejar el backend.
 */
@Injectable({ providedIn: 'root' })
export class SupersetService {
  private readonly http = inject(HttpClient);

  fetchGuestToken(scope: SupersetGuestTokenScope): Promise<string> {
    return firstValueFrom(
      this.http.post<SupersetGuestTokenResponse>(SUPERSET_CONFIG.guestTokenEndpoint, scope),
    ).then((response) => response.token);
  }
}
